import { useEffect } from 'react';

interface HelmetProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  schema?: object[];
}

export function Helmet({ title, description, keywords, canonicalUrl, schema }: HelmetProps) {
  useEffect(() => {
    document.title = title;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    setMeta('keywords', keywords);

    const link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (link) {
      link.setAttribute('href', canonicalUrl);
    }

    setMeta('og:title', title, true);
    setMeta('og:description', description, true);
    setMeta('og:url', canonicalUrl, true);

    setMeta('twitter:title', title);
    setMeta('twitter:description', description);

    if (schema) {
      const existingScripts = document.querySelectorAll('script[data-seo-schema]');
      existingScripts.forEach((s) => s.remove());

      schema.forEach((s) => {
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.setAttribute('data-seo-schema', 'true');
        script.textContent = JSON.stringify(s);
        document.head.appendChild(script);
      });
    }
  }, [title, description, keywords, canonicalUrl, schema]);

  return null;
}